// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-new-delivery-address-form {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-small);
}
.modal-new-delivery-address-form .vert-row {
  display: flex;
  gap: var(--spacing-small);
  margin-right: 0 !important;
  margin-left: 0 !important;
}
.modal-new-delivery-address-form .vert-row input {
  flex: 1;
  margin-right: 0 !important;
  margin-left: 0 !important;
}
.modal-new-delivery-address-form .vert-row .vert-input:focus {
  border-color: var(--color-highlight-lighter) !important;
}
.modal-new-delivery-address-form .vert-row .vert-select {
  flex: 1.1;
}
@media screen and (max-width: 768px) {
  .modal-new-delivery-address-form .vert-row {
    flex-direction: column;
  }
  .modal-new-delivery-address-form .vert-row input {
    min-height: 48px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/Forms/FormsDeliveryAddressStyles.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,yBAAA;AACF;AAJA;EAMI,aAAA;EACA,yBAAA;EACA,0BAAA;EACA,yBAAA;AACJ;AAVA;EAYM,OAAA;EACA,0BAAA;EACA,yBAAA;AACN;AAfA;EAiBM,uDAAA;AACN;AAlBA;EAqBM,SAAA;AAAN;AAIA;EACE;IAEI,sBAAA;EAHJ;EACA;IAKM,gBAAA;EAHN;AACF","sourcesContent":[".modal-new-delivery-address-form {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-small);\n\n  .vert-row {\n    display: flex;\n    gap: var(--spacing-small);\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n\n    input {\n      flex: 1;\n      margin-right: 0 !important;\n      margin-left: 0 !important;\n    }\n    .vert-input:focus {\n      border-color: var(--color-highlight-lighter) !important;\n    }\n\n    .vert-select {\n      flex: 1.1;\n    }\n  }\n}\n@media screen and (max-width: 768px) {\n  .modal-new-delivery-address-form {\n    .vert-row {\n      flex-direction: column;\n\n      input {\n        min-height: 48px;\n      }\n    }\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
